<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center >
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-btn to="/tickets" rounded color="#A5668B" class="text-white">
              <v-icon>mdi-backspace-reverse-outline</v-icon>
              بازگشت
            </v-btn>
            <v-card class="m-20">
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->

                <v-spacer/>
                {{ $route.meta.title }}
                <v-spacer/>

                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg12 xl12 class="p-2">
                    <v-text-field
                        v-model="title"
                        label="عنوان تیکت"
                        required
                        outlined

                    ></v-text-field>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">


<!--                    <v-select-->
<!--                        v-model="roleid"-->
<!--                        :rules="rules.status"-->
<!--                        :items="roles"-->
<!--                        item-text="name_fa"-->
<!--                        item-value="id"-->
<!--                        :error-messages="errors.role_id"-->
<!--                        label="انتخاب نقش"-->
<!--                        outlined-->
<!--                        dense-->
<!--                        return-object></v-select>-->



                    <v-select
                        v-model="selectedDepartment"
                        :items="departments"
                        item-text="title"
                        v-on:change="notifyStatus"
                        item-value="id"
                        outlined
                        label="دپارتمان"
                    >
                    </v-select>
                  </v-flex>



                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">

<!--  <p>اولویت بندی</p>-->

  <v-btn-toggle
      class="mr-8"
      v-model="importance"
      shaped
      color="#3294AA"
      mandatory
  >
    <v-btn value="3">
      معمولی
    </v-btn>

    <v-btn value="2">
      مهم
    </v-btn>

    <v-btn value="1">
      بسیار مهم
    </v-btn>


  </v-btn-toggle>

                  </v-flex>
                </v-row>


                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" v-if="notify">

<!--                    <ckeditor v-if="ckEditor"-->
<!--                              :editor="editor.editor" v-model="text" :config="editor.editorConfig"></ckeditor>-->
                  </v-flex>
                  <v-textarea v-model="text" dense outlined label="متن پیام"></v-textarea>

                </v-row>


                                <v-row>
                                  <v-flex xs12 sm12 md6 lg6 xl6 >
                                    <v-file-input
                                        v-model="attach"
                                        label="پیوست فایل"
                                        outlined
                                    ></v-file-input>
                                  </v-flex>
                                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                                                    <v-btn @click="addTicket" :loading="loading" color="#50858B"  class="text-white p-6 ml-30"
                                                    >
                                                      <v-icon class="ml-4">mdi-send</v-icon>
                                                      ارسال تیکت
                                                    </v-btn>
                                  </v-flex>
                                </v-row>

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import PermissionPicker from "@/view/pages/pickers/permissionPicker";
import userPicker from "@/view/pages/pickers/userPicker";


export default {
  components: {PermissionPicker, userPicker},
  data() {
    return {
      loading: false,
      title: '',
      notify: false,
      text: '',
      attach:null,
      ckEditor: false,
      importance:'',
      departments:[],
      selectedDepartment:null,
      textArea: true,
      notify_type: 'sms',
      status_types: [
        {name: 'info', value: 'اطلاع رسانی'},
        {name: 'success', value: 'موفقیت'},
        {name: 'warning', value: 'هشدار'},
        {name: 'danger', value: 'خطر'}
      ],
      notify_types: [
        {name: 'sms', value: 'پیامک'},
        {name: 'email', value: 'ایمیل'},
        {name: 'notification', value: 'اطلاع رسانی'},
        {name: 'push_notification', value: 'اطلاع رسانی پنل'}
      ],
      cost: '',
      users: [],
      extras: {
        notify_at: '',
        status_type: '',
        icon: ''
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
    }
  },
  created() {
    this.getDepartments()
  },
  methods: {
    addTicket() {

      let formData = new FormData();
      // formDataa.append('description', 'slmm')
      formData.append('title', this.title)
      formData.append('department_id', this.selectedDepartment)
      formData.append('importance', this.importance)
      formData.append('description', this.text)
      if (this.attach != null) formData.append('attach', this.attach);




      this.loading = true;
      this.requestApiPost('ticket', formData ,this.configurationFile()).then((response) => {
        this.loading = false;
        this.$toast.success('تیکت با موفقیت ارسال شد.');
        this.$router.push({name: 'tickets.index'});
      }).catch(({response}) => {
        console.log(response);
        this.errors = response.data;
        console.log(response.data);
        this.loading = false;
      });
    },

    getDepartments() {
      this.requestApiGet('department',
      ).then(response => {
        this.departments = response.data.data;
      })
    },


    notifyStatus(data) {
      if (data.name === 'sms') {
        console.log('ebi')
        this.ckEditor = false;
        this.textArea = true;
        this.notify = false
      } else {
        this.notify = true
        this.textArea = false;
        this.ckEditor = true;
        this.cost = '';
      }

    }
  }
}
</script>